module.exports = __webpack_public_path__ + "img/businessScopeImg1.606faed4.png";